import { useQuery } from '@tanstack/react-query';
import type { DevIdentitiesResponse } from '@cusp/contracts';
import { queryKeys } from '../queryKeys.js';
import { request } from '../request.js';

/**
 * The seeded identities available to switch between.
 *
 * The seed doesn't change mid-session, so cache it indefinitely and don't
 * retry: when the endpoint is off (production, or DATABASE_URL_ADMIN unset) it
 * 404s, and the switcher should say so immediately rather than after three
 * backoffs.
 */
export function useDevIdentities() {
  return useQuery({
    queryKey: queryKeys.devIdentities(),
    queryFn: ({ signal }) => request<DevIdentitiesResponse>('/v1/dev/identities', { signal }),
    staleTime: Infinity,
    retry: false,
  });
}
